import coachingCoachingSkillsPowerfulQuestionsTechniqueEn from './coaching-coachingSkills-powerfulQuestions-technique-en.md';
import coachingCoachingSkillsPowerfulQuestionsTechniqueFr from './coaching-coachingSkills-powerfulQuestions-technique-fr.md';
import coachingCoachingSkillsPowerfulQuestionsTechniqueEs from './coaching-coachingSkills-powerfulQuestions-technique-es.md';

const fileToPathMap = {
  'coaching-coachingSkills-powerfulQuestions-technique-en.md': coachingCoachingSkillsPowerfulQuestionsTechniqueEn,
  'coaching-coachingSkills-powerfulQuestions-technique-fr.md': coachingCoachingSkillsPowerfulQuestionsTechniqueFr,
  'coaching-coachingSkills-powerfulQuestions-technique-es.md': coachingCoachingSkillsPowerfulQuestionsTechniqueEs
};

export default fileToPathMap;



// WEBPACK FOOTER //
// ./src/data/pathways/pathway-playbook-content-files.js